import { AbstractControl, UntypedFormControl } from '@angular/forms';

export function checkboxDisableValidator(requiredControlName: string, requiredFields: AbstractControl) {
    return ((formControl: UntypedFormControl) => {
      let requiredCheckbox = requiredFields.get(requiredControlName)
      if (formControl.value === false && requiredCheckbox) {
        requiredCheckbox.setValue(false);
        requiredCheckbox.disable();
      } else {
        requiredCheckbox.enable();
      }
  
      return null;
    })
  }
  